import CountryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

export const getCountryIdOrFallback = (countryId: number): number => {
    const supportedCountry = CountryService.getCountryById(countryId);

    return supportedCountry?.id ?? WORLDWIDE_COUNTRY_ID;
};
